var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgShare(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.9609 6.17188C18.9609 7.56187 20.3409 9.77187 20.6209 12.3219",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M3.48828 12.3688C3.74828 9.82875 5.10828 7.61875 7.08828 6.21875",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M8.19141 20.9414C9.35141 21.5314 10.6714 21.8614 12.0614 21.8614C13.4014 21.8614 14.6614 21.5614 15.7914 21.0114",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M12.0613 7.70062C13.5966 7.70062 14.8413 6.45598 14.8413 4.92062C14.8413 3.38527 13.5966 2.14062 12.0613 2.14062C10.5259 2.14062 9.28125 3.38527 9.28125 4.92062C9.28125 6.45598 10.5259 7.70062 12.0613 7.70062Z",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M4.83078 19.9194C6.36613 19.9194 7.61078 18.6747 7.61078 17.1394C7.61078 15.604 6.36613 14.3594 4.83078 14.3594C3.29543 14.3594 2.05078 15.604 2.05078 17.1394C2.05078 18.6747 3.29543 19.9194 4.83078 19.9194Z",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M19.1706 19.9194C20.706 19.9194 21.9506 18.6747 21.9506 17.1394C21.9506 15.604 20.706 14.3594 19.1706 14.3594C17.6353 14.3594 16.3906 15.604 16.3906 17.1394C16.3906 18.6747 17.6353 19.9194 19.1706 19.9194Z",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShare);
export default __webpack_public_path__ + "static/media/share.03f7fa010fbafba10cf3a78c010a61cd.svg";
export { ForwardRef as ReactComponent };